namespace GeniuzPOS.InitialData {
    export interface PsCashierRow {
        Id?: number;
        CashierId?: string;
        CashierName?: string;
        CashierPassword?: string;
        CashierLevel?: CashierLevel;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
    }

    export namespace PsCashierRow {
        export const idProperty = 'CashierId';
        export const nameProperty = 'CashierId';
        export const localTextPrefix = 'InitialData.PsCashier';
        export const lookupKey = 'InitialData.PsCashier';

        export function getLookup(): Q.Lookup<PsCashierRow> {
            return Q.getLookup<PsCashierRow>('InitialData.PsCashier');
        }
        export const deletePermission = '1POSBASE:ข้อมูลอ้างอิง:การจัดการจุดขาย:แคชเชียร์:Delete';
        export const insertPermission = '1POSBASE:ข้อมูลอ้างอิง:การจัดการจุดขาย:แคชเชียร์:Modify';
        export const readPermission = '1POSBASE:ข้อมูลอ้างอิง:การจัดการจุดขาย:แคชเชียร์:View';
        export const updatePermission = '1POSBASE:ข้อมูลอ้างอิง:การจัดการจุดขาย:แคชเชียร์:Modify';

        export declare const enum Fields {
            Id = "Id",
            CashierId = "CashierId",
            CashierName = "CashierName",
            CashierPassword = "CashierPassword",
            CashierLevel = "CashierLevel",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate"
        }
    }
}
